import { Controller } from "@hotwired/stimulus";
import { getCanAndShouldUseScanner } from "../utils";

export default class extends Controller {
  static targets = ["link", "icon", "form"];
  static classes = ["scanIcon", "noScanIcon"];

  initialize() {
    getCanAndShouldUseScanner()
      .then(({ canUseScanner, shouldUseScanner }) => {
        this.canUseScanner = canUseScanner;
        this.shouldUseScanner = shouldUseScanner;
      })
      .catch((e) => {
        console.error(e);
        this.canUseScanner = false;
        this.shouldUseScanner = false;
      });
  }

  linkTargetConnected(linkElement) {
    if (this.shouldUseScanner === undefined) {
      setTimeout(() => this.linkTargetConnected(linkElement), 100);
      return;
    }
    this._updateAttrLink(linkElement, "href");
    const frameAttr = "data-turbo-frame";
    if (this.shouldUseScanner && linkElement.hasAttribute(frameAttr)) {
      linkElement.attributes.removeNamedItem(frameAttr);
    }
  }

  formTargetConnected(formElement) {
    if (this.shouldUseScanner === undefined) {
      setTimeout(() => this.formTargetConnected(formElement), 100);
      return;
    }
    this._updateAttrLink(formElement, "action");
  }

  _updateAttrLink(htmlElement, attributeName) {
    const link = htmlElement.getAttribute(attributeName);
    const url = new URL(link, window.location.href);
    url.searchParams.set("can_use_scanner", this.canUseScanner);
    url.searchParams.set("should_use_scanner", this.shouldUseScanner);
    htmlElement.setAttribute(attributeName, url.href);
  }

  iconTargetConnected(iconElement) {
    if (this.shouldUseScanner === undefined) {
      setTimeout(() => this.iconTargetConnected(iconElement), 100);
      return;
    }
    if (!this.shouldUseScanner) return;
    iconElement.classList.remove(...this.noScanIconClasses);
    iconElement.classList.add(...this.scanIconClasses);
  }
}
